import { withSuspense } from '@lib/common/hoc';
import { lazy } from 'react';

const CreateRelationPage = withSuspense(lazy(() => import('./create-relation-page')));
export default CreateRelationPage;
